import weiboSvg from '@/assets/svg/weibo.svg';
import weixinSvg from '@/assets/svg/weixin.svg';
import addressSvg from '@/assets/svg/address.svg';
import phoneSvg from '@/assets/svg/phone.svg';
import weixinIconSvg from '@/assets/svg/weixin_icon.svg';
import { getIntl } from '@/locales';
const intl = getIntl();

export interface IFooterData {
  title: string;
  visible?: boolean;
  content: {
    name?: string;
    linkUrl?: string;
    iconSvg?: string;
    type?: string;
    iconData?: {
      iconSvg: string;
      linkUrl: string;
    }[]; // icons map
  }[];
}

export const footerData: IFooterData[] = [
  {
    title: intl.formatMessage({
      id: 'iWeb.components.footer.footerData.booking',
      defaultMessage: '快捷预定',
    }),
    content: [
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.booking.reservation',
          defaultMessage: '预订酒店',
        }),
        linkUrl:
          'https://reservations.galaxymacau.com/ReservationWeb/Booking/Reservation.aspx?lang=zh-CN&_ga=2.41491426.1937036913.1575248662-155333891.1571213593&_gac=1.207760038.1573120288.EAIaIQobChMI1MWJ3OnX5QIVE3ZgCh0GEAV7EAAYASAAEgJkQvD_BwE&cin=25-Apr-2024&cout=26-Apr-2024',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.booking.dining',
          defaultMessage: '预订餐厅',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/dining/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.booking.ticketing',
          defaultMessage: '门票及表演',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/ticketing/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.booking.cinema',
          defaultMessage: '预订影票',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/cinema/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.booking.concerts',
          defaultMessage: '百老汇舞台',
        }),
        linkUrl: 'https://www.broadwaymacau.com.mo/cn/upcoming-events-and-concerts/',
      },
    ],
  },
  {
    title: intl.formatMessage({
      id: 'iWeb.components.footer.footerData.experience',
      defaultMessage: '无限体验',
    }),
    content: [
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.offers',
          defaultMessage: '推介优惠',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/macau-holiday-packages-special-offers/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.hotels',
          defaultMessage: '酒店住宿',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/eight-luxury-hotels-book-hotels-online/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.dining',
          defaultMessage: '餐  饮',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/dining/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.shopping',
          defaultMessage: '购  物',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/galaxy-promenade/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.grandResortDeck',
          defaultMessage: '天浪淘园',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/grand-resort-deck/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.galaxyCinema',
          defaultMessage: '「银河影院 」',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/cinema/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.spa',
          defaultMessage: 'SPA与休闲',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/spa-and-relaxation/spa/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.entertainment',
          defaultMessage: '娱  乐',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/entertainment/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.meetings',
          defaultMessage: '会议与活动',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/mice-old/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.creditCard',
          defaultMessage: '工银澳门银河信用卡',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/landing/icbc-galaxy-macau-credit-card/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.exploreGalaxy',
          defaultMessage: '探索银河',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/experience-best-galaxy-macau/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.experience.galaxyUltimateClub',
          defaultMessage: '银河致尚会',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/landing/galaxy-ultimate-club/',
      },
    ],
  },
  {
    title: intl.formatMessage({
      id: 'iWeb.components.footer.footerData.introduction',
      defaultMessage: '集团介绍',
    }),
    content: [
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.introduction.galaxyCompany',
          defaultMessage: '银河娱乐集团',
        }),
        linkUrl: 'https://www.galaxyentertainment.com/zh-hans',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.introduction.aboutUs',
          defaultMessage: '关于我们',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/about-us/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.introduction.contactUs',
          defaultMessage: '联系我们',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/contact-us/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.introduction.awards',
          defaultMessage: '奖项荣誉',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/awards/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.introduction.myGalaxyCareer',
          defaultMessage: '我的银河事业',
        }),
        linkUrl: 'https://www.mygalaxycareer.com/zh/',
      },
    ],
  },
  {
    title: intl.formatMessage({
      id: 'iWeb.components.footer.footerData.otherMembers',
      defaultMessage: '集团其他成员',
    }),
    content: [
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.otherMembers.broadwayMacau',
          defaultMessage: '澳门百老汇',
        }),
        linkUrl: 'https://www.broadwaymacau.com.mo',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.otherMembers.starWorldMacau',
          defaultMessage: '星际酒店',
        }),
        linkUrl: 'https://www.starworldmacau.com/en',
      },
    ],
  },
  {
    title: intl.formatMessage({
      id: 'iWeb.components.footer.footerData.mapAndTraffic',
      defaultMessage: '地图及交通资讯',
    }),
    content: [
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.mapAndTraffic.map',
          defaultMessage: '综合度假城地图',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/landing/map/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.mapAndTraffic.traffic',
          defaultMessage: '交通指南',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/getting-here/',
      },
      {
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.mapAndTraffic.parking',
          defaultMessage: '泊  车',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/5-hour-free-parking/',
      },
    ],
  },
  {
    title: intl.formatMessage({
      id: 'iWeb.components.Footer.FollowUs',
      defaultMessage: '关注我们',
    }),
    visible: true,
    content: [
      {
        type: 'icons',
        name: '',
        iconData: [
          {
            iconSvg: weiboSvg,
            linkUrl: 'https://www.weibo.com/galaxymacau/',
          },
          {
            iconSvg: weixinSvg,
            linkUrl: '',
          },
          {
            iconSvg: 'https://assets.galaxyresorts.com.cn/assets/tripAdvisor.3a205285416c3872ab10.svg',
            linkUrl: 'http://cn.tripadvisor.com/Hotel_Review-g664891-d2066995-Reviews-Galaxy_Hotel-Macau.html',
          },
        ],
      },
      {
        iconSvg: addressSvg,
        name: intl.formatMessage({
          id: 'iWeb.components.footer.footerData.followUs.address',
          defaultMessage: '地址: 「澳门银河」综合度假城 澳门路凼城',
        }),
        linkUrl: 'https://www.galaxyresorts.com.cn/getting-here/',
      },
      {
        iconSvg: phoneSvg,
        type: 'tel',
        name: intl.formatMessage({
          id: 'iWeb.components.footer.bookingTel',
          defaultMessage: '预订专线: +853 2888 0888',
        }),
      },
      {
        iconSvg: weixinIconSvg,
        name: intl.formatMessage({
          id: 'iWeb.components.footer.bookingWeixin',
          defaultMessage: '微信小程序',
        }),
      },
      {
        type: 'image',
        iconSvg:
          'https://assets.galaxyresorts.com.cn/media_library/galaxy-ultimate-mp-qrc-sc-20230214.png?x-oss-process=image/format%2Cwebp/quality%2Cq_75',
      },
    ],
  },
];

export const footerLinkData: IFooterData['content'] = [
  {
    name: intl.formatMessage({ id: 'iWeb.components.footer.footerLinkData.webSiteMap', defaultMessage: '网站地图' }),
    linkUrl: 'https://www.galaxyresorts.com.cn/sitemap/',
  },
  {
    name: intl.formatMessage({
      id: 'iWeb.components.footer.footerLinkData.privacyPolicy',
      defaultMessage: '隐私政策',
    }),
    linkUrl: 'https://www.galaxyresorts.com.cn/privacy-policy/',
  },
  {
    name: intl.formatMessage({
      id: 'iWeb.components.footer.footerLinkData.termsUse',
      defaultMessage: '使用条款',
    }),
    linkUrl: 'https://www.galaxyresorts.com.cn/terms-use/',
  },
  {
    name: intl.formatMessage({
      id: 'iWeb.components.footer.footerLinkData.fraudPrevention',
      defaultMessage: '提防伪冒网站行骗及电话诈骗',
    }),
    linkUrl: 'https://www.galaxyresorts.com.cn/fraud-prevention/',
  },
];
